import React from 'react';

// Listens for window events and updates an aria-live region
// Usage: window.dispatchEvent(new CustomEvent('aria-announce', { detail: 'message' } as any))

export const AriaAnnouncer: React.FC = () => {
  const [message, setMessage] = React.useState<string>("");

  React.useEffect(() => {
    const listener = (e: Event) => {
      try {
        const ce = e as CustomEvent<string> & { detail?: string };
        const text = (ce.detail as string) || '';
        setMessage(''); // flush first to ensure re-announce
        // Slight delay to trigger screen reader change detection
        setTimeout(() => setMessage(text), 50);
        // Auto-clear after a few seconds
        setTimeout(() => setMessage(''), 5000);
      } catch {
        // no-op
      }
    };
    window.addEventListener('aria-announce' as any, listener as any);
    return () => window.removeEventListener('aria-announce' as any, listener as any);
  }, []);

  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only" role="status">
      {message}
    </div>
  );
};
